// extracted by mini-css-extract-plugin
module.exports = {"Title_Card":"Title_Card_Title_Card__19c7U","left":"Title_Card_left__1wbgH","right":"Title_Card_right__9BZQv"};